import type { AxiosInstance, AxiosResponse } from 'axios';
import type { DokladyDokladSeznamDto } from '../generated';

export const identityDocumentQuery = async (
	axiosInstance: AxiosInstance
): Promise<AxiosResponse<DokladyDokladSeznamDto>> =>
	axiosInstance.get('/api/v1/doklady');
